import React, { useCallback } from 'react';
import {useNavigate} from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { HomeSectionProps } from './HomeSectionProps';

const CallToAction: React.FC<HomeSectionProps> = ({ className }) => {
  const { user, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const navigateToLogin = useCallback(() => {
    if (isAuthenticated && user) {
      navigate("/dashboard");
    } else {
      navigate("/login");
    }
  }, [isAuthenticated, user, navigate]);

  return (
    <section className={`py-5 keep-all ${className ?? ''}`} style={{ background: 'linear-gradient(to right, #dc2626, #3b82f6)' }}>
      <div className="container py-5 text-center text-white">
        <h2 className="display-5 fw-bold">지금 바로 나만의 드림팀을 구성하세요!</h2>
        <p className="lead text-white-50 my-4 mx-auto" style={{ maxWidth: '700px' }}>
          2025 KBO 시즌이 한창 진행 중입니다.<br />지금 바로 시작해서 친구들보다 앞서 나가세요!
        </p>
        <button className="btn btn-lg btn-light text-danger fw-bold" onClick={navigateToLogin}>
          지금 시작하기 <i className="bi bi-arrow-right ms-2"></i>
        </button>
      </div>
    </section>
  );
};

export default CallToAction;